<!--  -->
<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/kechegnxuxibg.png);">
            <div class="container">
                <div class="banner-tip">
                    <h2 class="banner-title">课程学习</h2>
                    <div class="bread-crumbs">
                      Test center
                    </div>
                </div>
            </div>
          </section>  
    <section>
      <div class="container section-heading">
                    <div class="twotip">
                        <img src="/static/img/apps_fill.png" class="courses-showing-icon"/><span class="courses-showing-text">精品课程</span>
                      </div>
                    <div class="search-box">
                        <input type="search" v-model="searchWords" placeholder="输入关键字...">
                        <button type="submit" @click="toPage(1)"><img src="/static/img/search-line.png" width="21" height="21"/></button>
                    </div>
                </div>
     </section>
      <section>
         <div class="fenl row">
            <div class="container" style="position: relative;">
                <div class="clickleft" @click="changeBtn('left')">

                </div>
                <div class="course-tab-wrap">
                    <ul ref="tablist" class="course-tab-list" role="tablist" :style="`width:${(courcates.length + 1) * 180}px;`" id="review">
                        <li>
                            <a @click="chgcourcate('全部课程')" role="tab" data-toggle="tab" :class="catesel == '全部课程' ? 'active' : ''" aria-selected="true">
                              全部课程
                            </a>
                        </li>
                        <li role="presentation" v-for="(courcate, index) in courcates" :key="index">
                            <a @click="chgcourcate(courcate.name)" role="tab" data-toggle="tab" :class="catesel == courcate.name ? 'active' : ''" aria-selected="true">
                                {{ courcate.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="clickright" @click="changeBtn('right')">

                </div>
            </div><!-- end col-lg-12 -->
        </div><!-- end row -->
      </section>
    <section class="course-area course-area4">   
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                            <div class="row course-block">
                                 <div class="col-lg-3" v-for="(course, index) in courses" :key="index">
                                    <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                        <div class="course-img">
                                            <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                            <div class="course-tooltip">
                                                <span v-if="course.spltip" class="tooltip-label">{{ course.spltip }}</span>
                                            </div>
                                        </div><!-- end course-img -->
                                        <div class="course-content">
                                            <h3 class="course__title">
                                                {{ course.title }}
                                            </h3>
                                            <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                            <div class="rating-wrap" v-else>5.0分</div>
                                            <span class="course-meta">{{ course.totalClass }}人学习</span>
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-4 -->
                                 <div class="col-lg-3" v-for="(course, index) in courses" :key="index">
                                      <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                          <div class="course-img">
                                              <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                              <div class="course-tooltip">
                                                  <span v-if="course.spltip" class="tooltip-label">{{ course.spltip }}</span>
                                              </div>
                                          </div><!-- end course-img -->
                                          <div class="course-content">
                                              <h3 class="course__title">
                                                  {{ course.title }}
                                              </h3>
                                              <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                              <div class="rating-wrap" v-else>5.0分</div>
                                              <span class="course-meta">{{ course.totalClass }}人学习</span>
                                          </div><!-- end course-content -->
                                      </div><!-- end course-item -->
                                  </div><!-- end col-lg-4 -->
                                   <div class="col-lg-3" v-for="(course, index) in courses" :key="index">
                                      <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                          <div class="course-img">
                                              <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                              <div class="course-tooltip">
                                                  <span v-if="course.spltip" class="tooltip-label">{{ course.spltip }}</span>
                                              </div>
                                          </div><!-- end course-img -->
                                          <div class="course-content">
                                              <h3 class="course__title">
                                                  {{ course.title }}
                                              </h3>
                                              <div class="rating-wrap" v-if="course.stars">{{ parseFloat(course.stars).toFixed(1) }}分</div>
                                              <div class="rating-wrap" v-else>5.0分</div>
                                              <span class="course-meta">{{ course.totalClass }}人学习</span>
                                          </div><!-- end course-content -->
                                      </div><!-- end course-item -->
                                  </div><!-- end col-lg-4 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                            <el-pagination
                            background
                            :page-size="8"
                            :hide-on-single-page="intTotal<=8"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      courses: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
      catesel: "全部课程",
      changeindex: 0,
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    let type = this.$route.query.type;
    let searchConditions = "";
    if(type){
        searchConditions = "&type=" + this.searchType;
    }
    let strsearchWords = this.$route.query.searchWords;
     if (strsearchWords) {
      searchConditions += "&title=$regex:" + strsearchWords;
    }
     let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
        searchConditions="";
      }
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
        this.tabwidth = (this.courcates.length) * 180 - 6 * 180;
      }
    });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=8&sort=-istop,-createdAt"+searchConditions+strextra)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      // this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    changeBtn(index) {
      let temp = this.changeindex * 180;
      if (index == 'left') {
        if (temp > 0) {
          this.changeindex = this.changeindex - 1;
          this.$refs.tablist.style.left = '-' + 180 * this.changeindex + 'px';
        }
      } else {
        console.log(this.changeindex);
        if (temp <= this.tabwidth) {
          this.changeindex = this.changeindex + 1;
          this.$refs.tablist.style.left = '-' + 180 * this.changeindex + 'px';
        }
      }

    },
    chgcourcate(cate) {
      this.catesel = cate;
      var searchConditions = "";
      if (this.catesel != "全部课程") {
        searchConditions += "&courseTypes=" + this.catesel;
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=1&limit=8${searchConditions}`
        ).then((res) => {
          if (res.data) {
            this.courses = res.data.data;
            this.intTotal = res.data.total;
          }
        });
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=-istop,-createdAt";
      }
      if (this.catesel != "全部课程") {
        searchConditions += "&courseTypes=" + this.catesel;
      }
      // if (this.searchPrice == "0") {
      //   searchConditions += "&price=0";
      // } else {
      //   searchConditions += "&price[ne]=0";
      // }
      let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=${
            this.intCurrent
          }&limit=8${searchConditions}${strextra}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
  },
};
</script>
<style scoped>
/* col-lg-3 */
.course-item{
  width: 278px;
height: 308px;
overflow: hidden;
display: flex;
flex-direction: column;
justify-content: start;
background: #FEFEFE;
box-shadow: 0px 0px 24px 0px rgba(211,211,225,0.58);
border-radius: 10px;
}
.course-img img{
width: 278px;
height: 207px;
}
.course-content{
  position: relative;
  margin-top: 17px;
  width: 278px;
height: 101px;
border:0;
background: #FEFEFE;
}
.course__title{
  margin-bottom: 8px;
  padding-left: 12px;
width: 190px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 18px;
 -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.rating-wrap{
  position: absolute;
  top:0;
  right: 15px;
  width: 48px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F55C57;
line-height: 18px;
}
.course-meta{
margin-left: 12px;
padding: 0 10px;
height: 28px;
background: #F6F6F6;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.section-heading{
  display: flex;
  justify-content: space-between;
}
.twotip {
  padding-left:21px ;
  padding-right: 35px;
  height: 66px;
  background: #4462CF;
  box-shadow: 0px 10px 29px 0px rgba(68, 98, 207, 0.39);
  border-radius: 5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
/* fenyeqi s */
.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
/* fenyeqi e */
.course__label-text{
    margin-left: 23px;
}
#review li a{
float: left;
width: 159px;
height: 49px;
background: #F1F3FA;
border-radius: 25px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 49px;
text-align: center;
  overflow: hidden;
}
#review li a.active{
background: #4462CF;
color: #FFFFFF;
}
.course-tab-wrap{
  position: relative;
  width: 1060px;
  height: 49px;
  margin: 0 70px 0;
  overflow: hidden;
}
#review{
  overflow: hidden;
   position: absolute;
   top:0;
   left: 0;
}
#review li{
  cursor: pointer;
float: left;
width: 159px;
height: 49px;
margin-right: 21px;
}
.col-lg-12{
  position: relative;
}
.clickleft{
  position: absolute;
  cursor: pointer;
  top:0;
  left:0;
  width: 40px;
height: 49px;
background-image: url(/static/img/zuohua.png);
background-repeat: no-repeat;
background-size: 40px 40px;
background-position: 0 center;
}
.clickright{
  position: absolute;
  cursor: pointer;
   top:0;
  right:0;
  width: 40px;
height: 49px;
background-image: url(/static/img/youhua.png);
background-repeat: no-repeat;
background-size: 40px 40px;
background-position: right center;
}
/* col-lg-3 */
.course-item{
  width: 278px;
height: 308px;
background: #FFFFFF;
border-radius: 10px;
overflow: hidden;
display: flex;
flex-direction: column;
justify-content: start;
}
.course-img img{
width: 278px;
height: 207px;
background: #FFFFFF;
}
.course-content{
  position: relative;
  margin-top: 17px;
  width: 278px;
height: 101px;
border:0;
}
.course__title{
  margin-top: 0;
  margin-bottom: 8px;
  padding-left: 12px;
width: 190px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 18px;
 -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.rating-wrap{
  position: absolute;
  top:0;
  right: 15px;
  width: 48px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F55C57;
line-height: 18px;
}
.course-meta{
margin-left: 12px;
padding: 0 10px;
height: 28px;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.course-area {
  margin-top: 0;
}
.fenl {
    margin-top: 54px;
}
</style>
